// src/components/admin/tabs/SectorsTab.js
import React, { useState, useContext, useEffect } from "react";
import {
  Card,
  Button,
  Table,
  Modal,
  Toast,
  ToastContainer,
  Alert,
} from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { DashboardContext } from "../../../contexts/AdminContext";
import SectorForm from "../forms/SectorForm";

const SectorsTab = () => {
  const { sectors, loading, error, deleteSector, fetchData } =
    useContext(DashboardContext);

  const [showSectorModal, setShowSectorModal] = useState(false);
  const [editingSector, setEditingSector] = useState(null);

  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [sectorToDelete, setSectorToDelete] = useState(null);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [localError, setLocalError] = useState("");

  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [toastVariant, setToastVariant] = useState("success");
  sectors.map((sector) => {
    console.log(sector);
    return null;
  });

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const showNotification = (message, variant = "success") => {
    setToastMessage(message);
    setToastVariant(variant);
    setShowToast(true);
  };

  const handleAddClick = () => {
    setEditingSector(null);
    setShowSectorModal(true);
  };

  const handleEditClick = (sector) => {
    setEditingSector(sector);
    setShowSectorModal(true);
  };

  const handleDeleteClick = (sector) => {
    setLocalError("");
    setSectorToDelete(sector);
    setShowDeleteModal(true);
  };

  const handleConfirmDelete = async () => {
    if (!sectorToDelete) return;

    if (sectorToDelete.machine_count > 0) {
      setLocalError(
        "Tidak dapat menghapus sektor karena masih memiliki mesin terkait",
      );
      return;
    }

    setDeleteLoading(true);

    try {
      const result = await deleteSector(sectorToDelete.id);

      if (result.success) {
        showNotification("Sektor berhasil dihapus");
        setShowDeleteModal(false);
        setSectorToDelete(null);
        await fetchData();
      } else {
        setLocalError(result.error || "Gagal menghapus sektor");
      }
    } catch (err) {
      setLocalError("Terjadi kesalahan saat menghapus sektor");
    } finally {
      setDeleteLoading(false);
    }
  };

  if (loading) {
    return <div className="text-center p-5">Memuat data...</div>;
  }

  return (
    <>
      <Card>
        <Card.Header className="d-flex justify-content-between align-items-center">
          <span>Manajemen Sektor</span>
          <Button size="sm" onClick={handleAddClick}>
            <FontAwesomeIcon icon={faPlus} /> Tambah Sektor
          </Button>
        </Card.Header>

        <Card.Body className="p-0">
          {error && <Alert variant="danger">{error}</Alert>}

          {/* Table wrapper dengan tinggi tetap dan scroll */}
          <div
            style={{
              maxHeight: "50%",
              overflowY: "auto",
            }}
            className="table-responsive"
          >
            <Table
              striped
              bordered
              hover
              className="mb-0"
              style={{ maxHeight: "100%" }}
            >
              <thead className="table-light">
                <tr>
                  <th
                    className="text-center"
                    style={{ background: "#1e3a8a", color: "#fff" }}
                  >
                    No
                  </th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>
                    Sector Line
                  </th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>
                    Leader
                  </th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>
                    Mesin
                  </th>
                  <th style={{ background: "#1e3a8a", color: "#fff" }}>
                    Tindakan
                  </th>
                </tr>
              </thead>
              <tbody>
                {sectors.length === 0 ? (
                  <tr>
                    <td colSpan="5" className="text-center">
                      Tidak ada sektor
                    </td>
                  </tr>
                ) : (
                  sectors.map((sector, index) => (
                    <tr key={sector.id}>
                      <td className="text-center">{index + 1}</td>
                      <td className="cell-left">{sector.name}</td>
                      <td className="cell-left">{sector.leader || "-"}</td>
                      <td>{sector.machine_count}</td>
                      <td>
                        <Button
                          size="sm"
                          variant="outline-primary"
                          className="me-2"
                          onClick={() => handleEditClick(sector)}
                        >
                          Edit
                        </Button>
                        <Button
                          size="sm"
                          variant="outline-danger"
                          disabled={sector.machine_count > 0}
                          onClick={() => handleDeleteClick(sector)}
                          title={
                            sector.machine_count > 0
                              ? "Masih ada mesin terkait"
                              : ""
                          }
                        >
                          Hapus
                        </Button>
                      </td>
                    </tr>
                  ))
                )}
              </tbody>
            </Table>
          </div>
        </Card.Body>
      </Card>

      <SectorForm
        show={showSectorModal}
        handleClose={() => setShowSectorModal(false)}
        initialData={editingSector}
      />

      <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Konfirmasi Hapus</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {localError && <Alert variant="danger">{localError}</Alert>}
          Yakin ingin menghapus sektor <b>{sectorToDelete?.name}</b>?
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowDeleteModal(false)}>
            Batal
          </Button>
          <Button
            variant="danger"
            onClick={handleConfirmDelete}
            disabled={deleteLoading}
          >
            {deleteLoading ? "Menghapus..." : "Hapus"}
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer position="top-end" className="p-3">
        <Toast
          bg={toastVariant}
          show={showToast}
          onClose={() => setShowToast(false)}
          delay={3000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">Notifikasi</strong>
          </Toast.Header>
          <Toast.Body className={toastVariant === "danger" ? "text-white" : ""}>
            {toastMessage}
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </>
  );
};

export default SectorsTab;
